import ViewSurveyQuestionCard from './viewSurveyQuestionCard.container'

export default ViewSurveyQuestionCard